import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { schema as accountSchema } from './account'

export { collection } from './account'

export const schema = new schemas.Array(accountSchema)

type FetchQueryType = {
  serviceId: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ serviceId }: FetchQueryType) =>
    callApi(`${apiBase}/services/${serviceId}/accounts`, schema)
